/* eslint-disable react/no-danger */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import { Text, mergeStyleSets } from '@fluentui/react';
import * as PropTypes from 'prop-types';
import { ServiceTile } from '@shared/containers/serviceTile';
import SpzaComponent from '@shared/components/spzaComponent';
import { MediaType } from '@shared/Models';
import { Constants } from '@shared/utils/constants';
import { Capabilities } from '@shared/utils/capabilities';
import * as DetailUtils from '@shared/utils/detailUtils';
import Ribbon from '@shared/components/ribbon';
import { TelemetryImage } from '@shared/components/telemetryImage';
import { AppTile } from '@shared/containers/appTile';
import { DataMap } from '@shared/utils/dataMapping';
import { ExternalLink } from '@shared/components/externalLink';
import { bitMasksMatch } from '@shared/utils/datamappingHelpers';
import { useTelemetry } from '@shared/hooks/useTelemetry';
import videoOverlay from '@shared/images/videoOverlay.png';
import classnames from 'classnames';
import { AutoRuns } from '@shared/utils/autoruns';
import { getProdcutBitMaskInfo } from '@shared/utils/appUtils';
import { SafeHtmlWrapper } from '@shared/components/safeHtmlWrapper';
// eslint-disable-next-line react-hooks/rules-of-hooks
const [{ pageAction }] = useTelemetry();
const contentStyles = mergeStyleSets({
    ulAutorunStyle: {
        'list-style': 'unset',
        'padding-left': 40,
        'margin-top': 8
    },
    autorunTitleStyle: {
        'margin-top': 8
    },
    ilTextAutorunStyle: {
        'font-size': 13
    }
});
export class Overview extends SpzaComponent {
    getMedia() {
        const images = this.props.images || [];
        const videos = this.props.videos || [];
        const mediaImages = images.map((image)=>({
                name: image.ImageName,
                link: image.ImageUri,
                thumbnail: image.ImageUri,
                type: MediaType.Image
            }));
        const mediaVideos = videos.map((video)=>({
                name: video.VideoName,
                link: video.VideoLink,
                thumbnail: video.ThumbnailURL,
                type: MediaType.Video
            }));
        return [
            ...mediaVideos,
            ...mediaImages
        ];
    }
    mediaRendering() {
        const mediaRender = [];
        const list = this.getMedia();
        if (!list.length) {
            return null;
        }
        for(let i = 0; i < list.length; i++){
            const item = list[`${i}`];
            if (!this.state.failures[item.thumbnail]) {
                const isVideo = item.type === MediaType.Video;
                mediaRender.push(/*#__PURE__*/ _jsxs("div", {
                    className: "imgContent",
                    tabIndex: 0,
                    onKeyPress: (event)=>{
                        if (event.charCode === Constants.SystemKey.Enter) {
                            this.onMediaItemSelect(item, i, list);
                        }
                    },
                    onClick: ()=>this.onMediaItemSelect(item, i, list),
                    children: [
                        /*#__PURE__*/ _jsx(TelemetryImage, {
                            src: item.thumbnail,
                            isVideo: true,
                            alt: `Snapshot ${i + 1} of ${this.props.ownerTitle}`,
                            ariaLabel: `At a glance ${isVideo ? 'video' : 'image'}`,
                            onError: ()=>{
                                this.setState({
                                    failures: _object_spread_props(_object_spread({}, this.state.failures), {
                                        [item.thumbnail]: true
                                    })
                                });
                            }
                        }),
                        isVideo ? /*#__PURE__*/ _jsx(TelemetryImage, {
                            className: "overlay",
                            src: videoOverlay,
                            alt: "detail page video overlay image"
                        }) : null
                    ]
                }, i));
            }
        }
        if (!mediaRender.length) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "appDetailMedia",
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "thumnailsTitle",
                    children: this.context.loc('Overview_Thumbnails')
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "thumbnails",
                    children: mediaRender
                })
            ]
        });
    }
    isPowerBiVisual() {
        const { property, mask } = getProdcutBitMaskInfo(DataMap.products.PowerBICustomVisual);
        return !!(this.props.products && bitMasksMatch(this.props.products, property, mask));
    }
    createDisclaimer() {
        if (!this.isPowerBiVisual()) {
            return /*#__PURE__*/ _jsx("div", {
                children: this.context.loc('CP_Disclaimer')
            });
        }
        if (this.isPowerBiVisual() && !this.props.isPowerBICertified) {
            return /*#__PURE__*/ _jsx("div", {
                children: this.context.loc('CP_Disclaimer_PowerBI')
            });
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: this.context.loc('CP_Disclaimer_Certified_PowerBI')
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(ExternalLink, {
                        className: "c-hyperlink",
                        href: Constants.learnMoreCertifiedPBI,
                        accessibilityEnabled: true,
                        children: /*#__PURE__*/ _jsxs("span", {
                            children: [
                                this.context.loc('PBI_LearnMore'),
                                "."
                            ]
                        })
                    })
                })
            ]
        });
    }
    capabilitiesRendering() {
        const capabilitiesPane = [];
        if (this.isPowerBiVisual() && this.props.isPowerBICertified) {
            return null;
        }
        if (this.isPowerBiVisual()) {
            return /*#__PURE__*/ _jsx("ul", {
                className: "capabilitiesList",
                children: /*#__PURE__*/ _jsx("li", {
                    className: "capabilitiesListItem",
                    children: this.context.loc('CP_10')
                }, 0)
            });
        }
        for(let i = 0; i < this.props.capabilities.length; i++){
            const capability = this.props.capabilities[`${i}`];
            const subCapabilities = Capabilities[`${capability}`];
            const subCapabilitiesCount = subCapabilities && subCapabilities.length ? subCapabilities.length : 0;
            for(let j = 0; j < subCapabilitiesCount; j++){
                capabilitiesPane.push(/*#__PURE__*/ _jsx("li", {
                    className: "capabilitiesListItem",
                    children: this.context.loc(subCapabilities[`${j}`])
                }, j));
            }
        }
        return capabilitiesPane.length ? /*#__PURE__*/ _jsx("ul", {
            className: "capabilitiesList",
            children: capabilitiesPane
        }) : null;
    }
    autorunRendering() {
        const { autoRunLaunchEvents } = this.props;
        const autorunsPane = autoRunLaunchEvents.filter((autorun)=>AutoRuns[`${autorun}`]).map((autorun)=>{
            const autorunInfo = AutoRuns[`${autorun}`];
            return /*#__PURE__*/ _jsx("li", {
                children: /*#__PURE__*/ _jsx(Text, {
                    className: contentStyles.ilTextAutorunStyle,
                    children: this.context.loc(autorunInfo.loc, autorunInfo.fallback)
                })
            }, autorun);
        });
        return (autorunsPane === null || autorunsPane === void 0 ? void 0 : autorunsPane.length) ? /*#__PURE__*/ _jsxs("div", {
            className: contentStyles.autorunTitleStyle,
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    variant: "smallPlus",
                    children: this.context.loc('Autorun_Title', 'This add-in can launch itself when:')
                }),
                /*#__PURE__*/ _jsx("ul", {
                    className: contentStyles.ulAutorunStyle,
                    children: autorunsPane
                })
            ]
        }) : null;
    }
    showMediaDialog(index, list) {
        DetailUtils.generateLinkPayloadAndLogTelemetry(this.props.ownerType, this.props.ownerId, 'OpenMediaModal', '', 'Overview');
        const jsllMediaType = list[`${index}`] ? list[`${index}`].type === MediaType.Image ? Constants.JsllSaas.ViewImage : Constants.JsllSaas.WatchVideo : '';
        pageAction(document.getElementById(this.props.ownerId), {
            contentTags: {
                contentId: jsllMediaType,
                contentName: this.props.ownerId,
                contentType: this.props.isSaaSTransactableApp
            }
        });
        this.props.openMediaModal({
            defaultIndex: index,
            media: list
        });
    }
    onMediaItemSelect(selected, index, list) {
        DetailUtils.generateLinkPayloadAndLogTelemetry(this.props.ownerType, this.props.ownerId, `Select${selected.type}`, // eslint-disable-next-line security/detect-non-literal-fs-filename
        selected.link, 'Overview');
        this.showMediaDialog(index, list);
    }
    renderDescription() {
        return /*#__PURE__*/ _jsx(SafeHtmlWrapper, {
            className: "description",
            html: this.props.description
        });
    }
    renderShortDescription() {
        return /*#__PURE__*/ _jsx(Text, {
            as: 'h2',
            className: this.props.description ? 'shortDescription' : 'description',
            children: /*#__PURE__*/ _jsx("div", {
                dangerouslySetInnerHTML: {
                    __html: this.props.shortDescription
                }
            })
        });
    }
    renderImpl() {
        var _this_props_autoRunLaunchEvents, _this_props_autoRunLaunchEvents1;
        const { TileType, crossListings } = this.props;
        const localizationTexts = [];
        let ribbonUrl = 'openTab';
        let ribbonSeeAllText = this.context.loc('Link_SeeAll', 'See all');
        let ribbonTitleParam = '';
        let ribbonKey = '';
        if (TileType === AppTile || TileType === ServiceTile) {
            var _crossListings_;
            const localizedTitleKey = this.getLocalizationKey(TileType);
            localizationTexts.push(localizedTitleKey);
            localizationTexts.push('');
            localizationTexts.push('');
            ribbonSeeAllText = '';
            ribbonUrl = null;
            ribbonTitleParam = (crossListings === null || crossListings === void 0 ? void 0 : (_crossListings_ = crossListings[0]) === null || _crossListings_ === void 0 ? void 0 : _crossListings_.publisher) || '';
            ribbonKey = `${localizedTitleKey} ${ribbonTitleParam}`;
        }
        const appDetailContentMaxWidthClasses = classnames({
            appDetailContent: true
        });
        return /*#__PURE__*/ _jsxs("div", {
            className: "overview overviewContent",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "detailsContentWrapper",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: appDetailContentMaxWidthClasses,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        this.renderShortDescription(),
                                        this.renderDescription()
                                    ]
                                }),
                                this.props.capabilities || ((_this_props_autoRunLaunchEvents = this.props.autoRunLaunchEvents) === null || _this_props_autoRunLaunchEvents === void 0 ? void 0 : _this_props_autoRunLaunchEvents.length) ? /*#__PURE__*/ _jsxs("div", {
                                    className: "capabilities",
                                    children: [
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "c-heading-6 capabilitiesTitle",
                                            children: this.context.loc(this.isPowerBiVisual() ? 'CP_Title_PowerBI' : 'CP_Title')
                                        }),
                                        this.props.capabilities && /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "disclaimer",
                                                    children: this.createDisclaimer()
                                                }),
                                                this.capabilitiesRendering()
                                            ]
                                        }),
                                        !!((_this_props_autoRunLaunchEvents1 = this.props.autoRunLaunchEvents) === null || _this_props_autoRunLaunchEvents1 === void 0 ? void 0 : _this_props_autoRunLaunchEvents1.length) && /*#__PURE__*/ _jsx(_Fragment, {
                                            children: this.autorunRendering()
                                        })
                                    ]
                                }) : null
                            ]
                        }),
                        this.mediaRendering()
                    ]
                }),
                (crossListings === null || crossListings === void 0 ? void 0 : crossListings.length) ? /*#__PURE__*/ _jsx(Ribbon, {
                    title: this.context.locParams(localizationTexts[0], [
                        ribbonTitleParam
                    ], localizationTexts[1]),
                    seeMoreUrl: ribbonUrl,
                    seeMoreText: ribbonSeeAllText,
                    subHeader: this.context.locParams(localizationTexts[2], [
                        this.props.ownerTitle
                    ], localizationTexts[3]),
                    children: crossListings.slice(0, Constants.crossListingRibbonItemCount).map((value, index, tiles)=>{
                        return /*#__PURE__*/ _createElement(this.props.TileType, _object_spread_props(_object_spread({}, value), {
                            item: value,
                            key: index,
                            customCSSClass: 'tile' + index,
                            totalTiles: tiles.length,
                            countryContext: this.props.countryCode,
                            ribbonKey: ribbonKey
                        }));
                    })
                }) : null
            ]
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "getLocalizationKey", (tileType)=>{
            const { isOneTimePayment } = this.props;
            if (tileType === AppTile) {
                return isOneTimePayment ? 'AppDetails_RibbonHeader_TeamOneTimePayment' : 'AppDetails_RibbonHeader';
            }
            if (tileType === ServiceTile) {
                return 'ServiceDetails_RibbonHeader';
            }
            return ''; // Shouldn't reach this case.
        });
        this.state = {
            failures: {}
        };
    }
}
Overview.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    renderErrorModal: PropTypes.func
};
